import {changeBusyAction, setPopupScreenAction} from '../store/ui/actions';
import {useDispatch} from 'react-redux';
import {useCallback} from 'react';
import {isPromise} from '../utils/promise';

export function useQuestion() {
    const dispatch = useDispatch();

    return useCallback((message: string, yesCallback?: () => void, noCallback?: () => void, positive_button?: { text: string; timed: boolean; }, showCancel?: boolean) => {
        dispatch(setPopupScreenAction(true, 'question', message, null, isApproved => {
            if (isApproved) {
                if (yesCallback) {
                    const output = yesCallback();
                    if (isPromise(output)) {
                        dispatch(changeBusyAction(true));
                        (output as unknown as Promise<unknown>).finally(() => {
                            dispatch(changeBusyAction(false));
                        });
                    }
                }
            } else {
                if (noCallback) {
                    const output = noCallback();
                    if (isPromise(output)) {
                        dispatch(changeBusyAction(true));
                        (output as unknown as Promise<unknown>).finally(() => {
                            dispatch(changeBusyAction(false));
                        });
                    }
                }
            }
        }, false, positive_button, showCancel));
    }, [dispatch]);
}
